import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { withEditorRef } from '../lib/editorRef';
import { Loader2 } from 'lucide-react';
import BookViewer from './BookViewer';
import BookLanding from './BookLanding';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function BookAccessGate({ editorId, editorSlug }) {
  const { bookId } = useParams();
  const [state, setState] = useState({ status: 'checking', notice: '' });

  useEffect(() => {
    const token = localStorage.getItem('subscriberToken');
    if (!token) { setState({ status: 'landing', notice: '' }); return; }
    axios.get(`${API}/digital/${editorId}/subscriber/profile?auth=${token}`)
      .then(({ data }) => {
        const expired = data.subscription_end && new Date(data.subscription_end) < new Date();
        if (data.status === 'active' && !expired) setState({ status: 'reader', notice: '' });
        else setState({ status: 'landing', notice: data.status === 'suspended' ? 'Seu usuário está suspenso nesta biblioteca. Entre em contato com a editora.' : 'Sua assinatura desta biblioteca não está ativa.' });
      })
      .catch(() => {
        localStorage.removeItem('subscriberToken');
        localStorage.removeItem('subscriberData');
        setState({ status: 'landing', notice: '' });
      });
  }, [editorId, bookId]);

  if (state.status === 'checking') {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a' }}><Loader2 className="w-10 h-10 animate-spin" style={{ color: '#68AAB0' }} /></div>;
  }
  if (state.status === 'reader') return <BookViewer editorId={editorId} editorSlug={editorSlug} />;
  return <BookLanding editorId={editorId} editorSlug={editorSlug} bookId={bookId} notice={state.notice} />;
}

export default withEditorRef(BookAccessGate);
